import { render, staticRenderFns } from "./EditAddTypeModal.vue?vue&type=template&id=a2f4fe6c&scoped=true&"
import script from "./EditAddTypeModal.vue?vue&type=script&lang=js&"
export * from "./EditAddTypeModal.vue?vue&type=script&lang=js&"
import style0 from "./EditAddTypeModal.vue?vue&type=style&index=0&id=a2f4fe6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f4fe6c",
  null
  
)

export default component.exports